import { IIconProps } from "../types"

export default function IconLR4(props: IIconProps) {
  const width = props.size || props.width || 61
  const height = props.size || props.height || 82
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 61 82"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.6368 1.86944C26.7668 0.409436 29.7668 0.0794365 32.6968 0.859436C35.6268 1.63944 38.4868 3.52944 41.4168 5.44944C44.3468 7.36944 47.3468 9.32944 49.9168 11.2794C52.4868 13.2294 54.6368 15.1794 56.1968 16.8094C57.7568 18.4394 58.7368 19.7394 59.2868 22.1194C59.8468 24.4994 59.9768 27.9494 59.4868 32.4694C58.9968 36.9994 57.8868 42.5894 56.0968 48.8394C54.3068 55.0994 51.8368 61.9994 49.6568 67.1394C47.4768 72.2794 45.5868 75.6694 43.1468 77.9094C40.7068 80.1594 37.7068 81.2694 34.3268 81.3294C30.9368 81.3994 27.1568 80.4194 24.1068 78.8594C21.0468 77.2994 18.6968 75.1494 16.4568 71.4394C14.2068 67.7194 12.0568 62.4494 9.71678 55.7394C7.36678 49.0394 4.82678 40.8994 3.13678 34.8494C1.44678 28.7894 0.596779 24.8194 0.466779 21.5294C0.336779 18.2394 0.926779 15.6394 2.29678 13.5894C3.65678 11.5394 5.80678 10.0394 9.51678 7.98944C13.2268 5.93944 18.5068 3.33944 22.6368 1.86944Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="0.9"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
